<template>
  <a v-if="href && external" :href="href" target="_blank" rel="noopener" :class="classes()">
    <ButtonLabel v-bind="{ ...labelProps, label }" @click="onButtonClick()" />
  </a>
  <router-link v-else-if="href && !external" :to="href" :class="classes()">
    <ButtonLabel
      v-bind="{ ...labelProps, label }"
      @click="onButtonClick()"
      tabindex="0"
      role="button"
    />
  </router-link>
  <button v-else :class="classes()" :type="submit ? 'submit' : 'button'" @click="onButtonClick()">
    <template v-if="iconName && !loading">
      <Icon :color="type === 'primary' ? 'neutral0' : 'primaryBlue'" :name="iconName" size="m" />
    </template>
    <template v-else>
      <ButtonLabel v-bind="{ ...labelProps, label }" :class="`${el}__label`" />
      <Spinner
        v-if="loading"
        :class="`${el}__spinner`"
        :color="type === 'outlined' ? 'primaryBlueLight' : 'neutral0'"
        :size="small ? 's' : 'm'"
      />
    </template>
  </button>
</template>

<script>
import Icon from '@/objects/Icon';
import Spinner from '@/objects/Spinner';
import ButtonLabel from './ButtonLabel';
import { IconNameTypes } from '@/constants/enums';
export default {
  name: 'Button',
  props: {
    label: String,
    iconName: {
      type: String,
      validator: (val) => IconNameTypes.includes(val),
    },
    additionalIconName: {
      type: String,
      validator: (val) => IconNameTypes.includes(val),
    },
    additionalIconPos: {
      type: String,
      default: 'right',
      validator: (val) => ['left', 'right'].includes(val),
    },
    type: {
      type: String,
      default: 'primary',
      validator: (val) => ['primary', 'secondary', 'outlined', 'text'].includes(val),
    },
    submit: Boolean,
    small: Boolean,
    disabled: Boolean,
    transparent: Boolean,
    external: Boolean,
    expand: Boolean,
    loading: Boolean,
    href: String,
    onClick: Function,
  },
  components: {
    Icon,
    Spinner,
    ButtonLabel,
  },
  data() {
    const el = 'o-button';
    return {
      el,
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--${this.type}`]: true,
          [`${el}__iconBtn`]: this.iconName,
          [`${el}--small`]: this.small,
          [`${el}--disabled is-disabled`]: this.disabled,
          [`${el}--expand`]: this.expand,
          [`${el}--loading`]: this.loading,
          [`${el}--transparent`]: this.transparent,
        };
      },
      labelProps: {
        additionalIconName: this.additionalIconName,
        additionalIconPos: this.additionalIconPos,
        additionalIconProps: {
          color: this.type === 'primary' ? 'neutral0' : 'primaryBlue',
          class: `${el}__additionalIcon ${el}__additionalIcon--${this.additionalIconPos}`,
          size: this.small ? 'm' : 'l',
        },
      },
    };
  },
  methods: {
    onButtonClick() {
      if (this.onClick) {
        this.onClick();
      }
      this.$emit('click');
    },
  },
};
</script>
